// Pages Imports
import HomeScreen from "pages/modules/home-v2/HomeScreen";
import { lazy } from "react";
import { BrowserRouter, Navigate, Route } from "react-router-dom";
import {
  BillingLayout,
  ControlCenterLayout,
  CustomersLayout,
  ReportsLayout,
  ServiceDeskLayout,
} from "../layouts/page-layouts";
import Landingpage from "../pages/modules/landing";

// Control Center module

// Configuration sub components

// Customers Module

import { ErrorInvalidLink } from "components";
import { CustomerOnBoardingWrapper } from "layouts/CustomerOnBoardingWrapper";
import { FeatureFlagWrapper } from "layouts/FeatureFlagWrapper";
import { ModuleWrapper } from "layouts/ModuleWrapper";
import { PermissionWrapper } from "layouts/PermissionWrapper";
import { UserOnBoardingWrapper } from "layouts/UserOnBoardingWrapper";
import { Error404Screen } from "pages/error-screens";
import { UnautherizedScreen } from "pages/error-screens/UnautherizedScreen";
import {
  AuthValidator,
  InvitationHandler,
  SecureWrapper,
} from "pages/modules/auth";
import { PayNowScreen } from "pages/modules/billing/pay-now/PayNowScreen";
import { RECURRING_INVOICE_V2_EDIT_ENABLED } from "pages/modules/billing/recurring-invoice/config";
import {
  QaRulesScreen,
  ServiceDeskTimesheetComponent,
} from "pages/modules/control-center/configurations/components";
import {
  ServiceDeskBillingEmailTemplateComponent,
  ServiceDeskBillingExpense,
  ServiceDeskBillingProduct,
  ServiceDeskBillingTax,
} from "pages/modules/control-center/configurations/components/service-desk-billing";
import { IntegrationHomeScreen } from "pages/modules/control-center/integrations";
import { SubscriptionHomeScreen } from "pages/modules/control-center/subscription";
import { CustomerUserNotifications } from "pages/modules/customer/customers/components/notifications-tab";
import {
  KbCentralKb,
  KbFolderView,
  KbRecentlyVisited,
  KbStarred,
} from "pages/modules/kb";
import { SharedArticle } from "pages/modules/kb/SharedArticle";
import { PERMISSIONS } from "shared";
import { SentryRoutes } from "utilz";

// import {
//   OnboardingBillingSettings,
//   OnboardingChannels,
//   OnboardingCompanyProfile,
//   OnboardingCustomers,
//   OnboardingIntegrations,
//   OnboardingReady,
//   OnboardingSampleData,
//   OnboardingTeam,
// } from "pages/modules/onboarding-new";

const GeneralSettingsTab = lazy(
  () =>
    import(
      "pages/modules/customer/customers/components/settings-tab/tabs/GeneralSettingsTab"
    ),
);

// customer import start
const CustomerHomeScreen = lazy(
  () => import("pages/modules/customer/customers/CustomerHomeScreen"),
);
const CustomerDetailsScreen = lazy(
  () => import("pages/modules/customer/customers/CustomerDetailsScreen"),
);
// customer import end

// user import start //
const UserHomeScreen = lazy(
  () => import("pages/modules/customer/users/UserHomeScreen"),
);
const UserDetailsScreen = lazy(
  () => import("pages/modules/customer/users/UserDetailsScreen"),
);
// user import end //

// archives imports start
const ArchivePage = lazy(() => import("pages/modules/archive/ArchivePage"));
// archives imports end

const AnnouncementsHomePage = lazy(
  () =>
    import("pages/modules/service-desk/announcements/AnnouncementsHomePage"),
);
// ping imports end

// service desk imports start
const ProjectWrapper = lazy(
  () => import("pages/modules/service-desk/projects/ProjectWrapper"),
);

const ProjectsHomeScreen = lazy(
  () => import("pages/modules/service-desk/projects/ProjectHomeScreen"),
);
const ProjectDetailsScreen = lazy(
  () => import("pages/modules/service-desk/projects/ProjectDetailsScreen"),
);

const TaskDetailsScreen = lazy(
  () => import("pages/modules/service-desk/projects/TaskDetailsScreen"),
);
const TicketsHomeScreen = lazy(
  () => import("pages/modules/service-desk/tickets/TicketsHomeScreen"),
);

const TicketDetailsScreen = lazy(
  () =>
    import(
      "pages/modules/service-desk/tickets/components/ticket-details/TicketDetailsScreen"
    ),
);

const ApprovalsTable = lazy(
  () =>
    import("pages/modules/service-desk/timesheets/components/ApprovalsTable"),
);

const TimesheetHomeScreen = lazy(
  () => import("pages/modules/service-desk/timesheets/TimesheetHomeScreen"),
);
const TimesheetTab = lazy(
  () => import("pages/modules/service-desk/timesheets/components/TimesheetTab"),
);

const SubmittedTimesheetTab = lazy(
  () =>
    import(
      "pages/modules/service-desk/timesheets/components/SubmittedTimesheetTab"
    ),
);
const TimesheetDetailsScreen = lazy(
  () => import("pages/modules/service-desk/timesheets/TimesheetDetailsScreen"),
);
// service desk imports end

// reporting imports start
const ReportDetailsScreen = lazy(
  () => import("pages/modules/report/reports/ReportDetailsScreen"),
);
const ReportsListScreen = lazy(
  () => import("pages/modules/report/reports/ReportsListScreen"),
);
const ReportsDashboardScreen = lazy(
  () => import("pages/modules/report/dashboard/ReportsDashboardScreen"),
);

// reporting imports end

// const ContractDetailsPage = lazy(
//   () => import("pages/modules/billing-new/contracts/ContractDetailsPage")
// );
const InvoicePage = lazy(
  () => import("pages/modules/billing/Invoice/InvoicePage"),
);

const InvoiceFormPage = lazy(
  () => import("pages/modules/billing/invoice-form/InvoiceFormPage"),
);
const ReadyToBillPage = lazy(
  () => import("pages/modules/billing/ready-to-bill/ReadyToBillPage"),
);

const ContractsPage = lazy(
  () => import("pages/modules/billing/contracts/ContractsPage"),
);

const EditContractPage = lazy(
  () => import("pages/modules/billing/contracts/EditContractPage"),
);

const InvoiceDraftTab = lazy(
  () => import("pages/modules/billing/Invoice/components/InvoiceDraftTab"),
);

const InvoicePageTab = lazy(
  () => import("pages/modules/billing/Invoice/components/InvoicePageTab"),
);

// const RecurringInvoiceWrapper = lazy(
//   () =>
//     import("pages/modules/billing/recurring-invoice/RecurringInvoiceWrapper")
// );

const RecurringInvoiceWrapper = lazy(
  () =>
    import("pages/modules/billing/recurring-invoice/RecurringInvoiceWrapper"),
);
// const RecurringInvoicePage = lazy(
//   () => import("pages/modules/billing/recurring-invoice/RecurringInvoiceHome")
// );
const RecurringInvoicePage = lazy(
  () => import("pages/modules/billing/recurring-invoice/RecurringInvoiceHome"),
);
// const RecurringInvoiceDetailsPage = lazy(
//   () =>
//     import(
//       "pages/modules/billing/recurring-invoice/RecurringInvoiceFormMainPage"
//     )
// );
const RecurringInvoiceDetailsPage = lazy(
  () =>
    import(
      "pages/modules/billing/recurring-invoice/RecurringInvoiceFormMainPage"
    ),
);
// v2 edit page — served on /:invoiceId while RECURRING_INVOICE_V2_EDIT_ENABLED.
const EditRecurringInvoicePage = lazy(
  () =>
    import("pages/modules/billing/recurring-invoice/EditRecurringInvoicePage"),
);
const HowTo = lazy(() => import("pages/modules/how-to/HowTo"));
// const Onboarding = lazy(
//   () => import("pages/modules/onboarding-new/Onboarding")
// );

// control center imports  start

const Automation = lazy(
  () => import("pages/modules/control-center/automation/Automation"),
);
const AutomationCreate = lazy(
  () => import("pages/modules/control-center/automation/AutomationCreate"),
);

const AutomationDetailsScreen = lazy(
  () =>
    import("pages/modules/control-center/automation/AutomationDetailsScreen"),
);

// ncentral
const IntegrationsDetailsPage = lazy(
  () =>
    import(
      "pages/modules/control-center/integrations/components/ncentral/IntegrationsDetailsScreen"
    ),
);

// level
const LevelIntegrationsDetailsPage = lazy(
  () =>
    import(
      "pages/modules/control-center/integrations/components/level/IntegrationsDetailsScreen"
    ),
);

// datto
const DattoIntegrationsDetailsPage = lazy(
  () =>
    import(
      "pages/modules/control-center/integrations/components/datto/IntegrationsDetailsScreen"
    ),
);

// pax8
const Pax8ConnectPage = lazy(
  () =>
    import(
      "pages/modules/control-center/integrations/components/pax8/Pax8Connect"
    ),
);
const Pax8ConfigurePage = lazy(
  () =>
    import(
      "pages/modules/control-center/integrations/components/pax8/Pax8Configure"
    ),
);
const Pax8CustomerMappingPage = lazy(
  () =>
    import(
      "pages/modules/control-center/integrations/components/pax8/Pax8CustomerMapping"
    ),
);
const Pax8SubscriptionMappingPage = lazy(
  () =>
    import(
      "pages/modules/control-center/integrations/components/pax8/Pax8SubscriptionMapping"
    ),
);
const Pax8SubscriptionSuccessPage = lazy(
  () =>
    import(
      "pages/modules/control-center/integrations/components/pax8/Pax8SubscriptionSuccess"
    ),
);

// hudu
const HuduIntegrationsDetailsPage = lazy(
  () =>
    import(
      "pages/modules/control-center/integrations/components/hudu/IntegrationsDetailsScreen"
    ),
);

// ninja one
const NinjaIntegrationsDetailsPage = lazy(
  () =>
    import(
      "pages/modules/control-center/integrations/components/ninja-one/NinjaIntegrationsDetailsScreen"
    ),
);

const IntegrationsDetailsScreenPage = lazy(
  () =>
    import(
      "pages/modules/control-center/integrations/components/ninja-one/IntegrationsDetailsScreen"
    ),
);

// qb
const QbDetailsPage = lazy(
  () =>
    import(
      "pages/modules/control-center/integrations/components/qb/QbDetailsPage"
    ),
);
const QbSuccessScreen = lazy(
  () =>
    import(
      "pages/modules/control-center/integrations/components/qb/QbSuccessScreen"
    ),
);

const QbCallbackScreen = lazy(
  () =>
    import(
      "pages/modules/control-center/integrations/components/qb/QbCallbackFile"
    ),
);
const QbConfigurationWrapper = lazy(
  () =>
    import(
      "pages/modules/control-center/integrations/components/qb/QbConfigurationWrapper"
    ),
);

// xero
const XeroDetailsPage = lazy(
  () =>
    import(
      "pages/modules/control-center/integrations/components/xero/XeroDetailsPage"
    ),
);
const XeroSuccessScreen = lazy(
  () =>
    import(
      "pages/modules/control-center/integrations/components/xero/XeroSuccessScreen"
    ),
);
const XeroCallbackScreen = lazy(
  () =>
    import(
      "pages/modules/control-center/integrations/components/xero/XeroCallbackFile"
    ),
);
const XeroConfigurationWrapper = lazy(
  () =>
    import(
      "pages/modules/control-center/integrations/components/xero/XeroConfigurationWrapper"
    ),
);

// stripe
const StripeDetailsPage = lazy(
  () =>
    import(
      "pages/modules/control-center/integrations/components/stripe/StripeDetailsPage"
    ),
);
const StripeSuccessScreen = lazy(
  () =>
    import(
      "pages/modules/control-center/integrations/components/stripe/StripeSuccessScreen"
    ),
);

const BillingAndInvoiceTab = lazy(
  () =>
    import(
      "pages/modules/customer/customers/components/billing-contract-tab/tabs/BillingAndInvoiceTab"
    ),
);

const ContractTab = lazy(
  () =>
    import(
      "pages/modules/customer/customers/components/billing-contract-tab/tabs/ContractTab"
    ),
);

const SlaTab = lazy(
  () =>
    import(
      "pages/modules/customer/customers/components/billing-contract-tab/tabs/SlaTab"
    ),
);

const ControlCenterScreen = lazy(
  () => import("pages/modules/control-center/ControlCenterScreenSwitch"),
);

const RecurringTicketsPage = lazy(
  () =>
    import(
      "pages/modules/control-center/recurring-tickets/RecurringTicketsPage"
    ),
);

const AgentConfigScreen = lazy(() => import("pages/modules/agent-config"));

// Dispatch Portal — NEW implementation, built on the @deskday/calendar package.
const DispatchPortalScreen = lazy(
  () => import("pages/modules/dispatch-portal"),
);

const ApiKeysPage = lazy(
  () => import("pages/modules/control-center/api-keys/ApiKeysPage"),
);

const CustomFieldsScreen = lazy(
  () => import("pages/modules/control-center/custom-fields/CustomFieldsScreen"),
);
const CompanyProfileScreen = lazy(
  () =>
    import("pages/modules/control-center/company-profile/CompanyProfileScreen"),
);
const BrandingScreen = lazy(
  () => import("pages/modules/control-center/branding/BrandingScreen"),
);

const SecurityScreen = lazy(
  () => import("pages/modules/control-center/security/SecurityScreen"),
);

const ResourceTypeScreen = lazy(
  () => import("pages/modules/control-center/resource-type/ResourceTypeScreen"),
);

const RolesAndPermissionScreen = lazy(
  () =>
    import(
      "pages/modules/control-center/roles-and-permission/RolesAndPermissionScreen"
    ),
);

const RolesAndPermissionsLanding = lazy(
  () =>
    import(
      "pages/modules/control-center/roles-and-permission/RolesAndPermissionsLanding"
    ),
);

const LocationScreen = lazy(
  () => import("pages/modules/control-center/location/LocationScreen"),
);

const TemplateScreen = lazy(
  () => import("pages/modules/control-center/template/TemplateScreen"),
);

const TicketsTemplateTab = lazy(
  () =>
    import("pages/modules/control-center/template/tickets/TicketsTemplateTab"),
);

const ProjectsTemplateTab = lazy(
  () =>
    import(
      "pages/modules/control-center/template/projects/ProjectsTemplateTab"
    ),
);

const ResourceScreen = lazy(
  () => import("pages/modules/control-center/resource/ResourceScreen"),
);

const ResourceDetailsScreen = lazy(
  () => import("pages/modules/control-center/resource/ResourceDetailsScreen"),
);

const ChecklistScreen = lazy(
  () => import("pages/modules/control-center/checklist/ChecklistScreen"),
);

const BoardsScreen = lazy(
  () => import("pages/modules/control-center/boards/BoardsScreen"),
);
const SLAScreen = lazy(
  () => import("pages/modules/control-center/sla/SLAScreen"),
);
const CannedNotesScreen = lazy(
  () => import("pages/modules/control-center/canned-notes/CannedNotesScreen"),
);

const TagsScreen = lazy(
  () => import("pages/modules/control-center/tags/TagsScreen"),
);

const BillingSettingsScreen = lazy(
  () =>
    import(
      "pages/modules/control-center/billing-settings/BillingSettingScreen"
    ),
);

const Notifications = lazy(
  () => import("pages/modules/control-center/notifications/Notifications"),
);

const SkillsScreen = lazy(
  () => import("pages/modules/control-center/skills/SkillsScreen"),
);

const BillingRolesScreen = lazy(
  () => import("pages/modules/control-center/billing-roles/BillingRolesScreen"),
);

const RoleProfilesScreen = lazy(
  () => import("pages/modules/control-center/role-profiles/RoleProfilesScreen"),
);

const RoleProfileDetailScreen = lazy(
  () =>
    import(
      "pages/modules/control-center/role-profiles/RoleProfileDetailScreen"
    ),
);

const ServiceCategoriesScreen = lazy(
  () =>
    import(
      "pages/modules/control-center/service-categories/ServiceCategoriesScreen"
    ),
);

const ServiceStatusScreen = lazy(
  () =>
    import("pages/modules/control-center/service-status/ServiceStatusScreen"),
);

const DefaultSettingsScreen = lazy(
  () =>
    import(
      "pages/modules/control-center/default-settings/DefaultSettingsScreen"
    ),
);

const BoardsV2Screen = lazy(
  () => import("pages/modules/control-center/boards-v2/BoardsV2Screen"),
);

const TeamMembersScreen = lazy(
  () => import("pages/modules/control-center/team-members/TeamMembersScreen"),
);

const TeamMemberDetailScreen = lazy(
  () =>
    import("pages/modules/control-center/team-members/TeamMemberDetailScreen"),
);

const BoardsV2DetailScreen = lazy(
  () => import("pages/modules/control-center/boards-v2/BoardsV2DetailScreen"),
);

// control center imports  end
// profile import start
const MyAccount = lazy(() => import("pages/modules/my-account/MyAccount"));
// profile import end

// qa import start
const QaBoardHomeScreen = lazy(
  () => import("pages/modules/service-desk/qa-board/QaBoardHomeScreen"),
);

const QaCustomerFeedback = lazy(
  () => import("pages/modules/service-desk/qa-board/QaCustomerFeedback"),
);
// qa import end
const Channels = lazy(
  () => import("pages/modules/control-center/channels/Channels"),
);

const StanderdisedTemplateScreen = lazy(
  () =>
    import(
      "pages/modules/control-center/standardized-templates/StanderdisedTemplateScreen"
    ),
);

const EmailSignatureScreen = lazy(
  () => import("pages/modules/control-center/email-signature/SignatureScreen"),
);

const TechData = lazy(
  () =>
    import(
      "pages/modules/control-center/standardized-templates/email-template/TechData"
    ),
);

const ServiceDeskDiscountTable = lazy(
  () =>
    import(
      "pages/modules/control-center/configurations/components/service-desk-billing/ServiceDeskDiscountTable"
    ),
);
const KbLayout = lazy(() => import("pages/modules/kb/layouts/KbLayout"));
const KbDetailScreen = lazy(() => import("pages/modules/kb/KbDetailScreen"));
const AgentActivationSuccessScreen = lazy(
  () => import("pages/auth-screens/AgentActivationSuccessScreen"),
);
const LoginScreen = lazy(() => import("pages/modules/auth/LoginScreen"));
const RegisterScreen = lazy(() => import("pages/modules/auth/RegisterScreen"));

const Router = () => {
  return (
    <BrowserRouter>
      <SentryRoutes>
        <Route path={"/"} element={<Landingpage />} />
        <Route path="callback" element={<AuthValidator />} />
        <Route
          path="agent-activation-success"
          element={<AgentActivationSuccessScreen />}
        />
        <Route path="login" element={<LoginScreen />} />
        <Route path="register" element={<RegisterScreen />} />
        <Route path="invite" element={<InvitationHandler />} />
        <Route path="invite-user" element={<InvitationHandler />} />

        {/* Unauthenticated route for shared KB articles */}
        <Route path="article/:article_id" element={<SharedArticle />} />

        {/* Unauthenticated invoice payment landing route */}
        <Route path="pay-now" element={<PayNowScreen />} />

        <Route path={"app"} element={<SecureWrapper />}>
          <Route index element={<Navigate to={"home"} />} />
          <Route path="how-to" element={<HowTo />} />
          <Route path={"profile"} element={<MyAccount />} />
          <Route path={"home"} element={<HomeScreen />} />
          <Route path={"archive/:type"} element={<ArchivePage />} />
          {/* New Control Center */}
          <Route
            path="control-center"
            element={
              <ModuleWrapper module="CC">
                <ControlCenterLayout />
              </ModuleWrapper>
            }
          >
            <Route
              index
              element={
                <ModuleWrapper module="CC">
                  <ControlCenterScreen />
                </ModuleWrapper>
              }
            />
            <Route path={"automation"}>
              <Route
                index
                element={
                  <PermissionWrapper permission={PERMISSIONS.CC.CC_WORKFLOW_RW}>
                    <Automation />
                  </PermissionWrapper>
                }
              />

              <Route element={<AutomationCreate />} path="created" />
              <Route
                path=":occasion"
                element={
                  <PermissionWrapper permission={PERMISSIONS.CC.CC_WORKFLOW_RW}>
                    <AutomationDetailsScreen />
                  </PermissionWrapper>
                }
              />
              <Route
                path="edit/:occasion/:workflowId"
                element={
                  <PermissionWrapper permission={PERMISSIONS.CC.CC_WORKFLOW_RW}>
                    <AutomationDetailsScreen />
                  </PermissionWrapper>
                }
              />
            </Route>
            <Route path={"resources"}>
              <Route
                index
                element={
                  <PermissionWrapper permission={PERMISSIONS.CC.CC_RESOURCE_RW}>
                    <ResourceScreen />
                  </PermissionWrapper>
                }
              />
              <Route
                path={":id"}
                element={
                  <PermissionWrapper permission={PERMISSIONS.CC.CC_RESOURCE_RW}>
                    <ResourceDetailsScreen />
                  </PermissionWrapper>
                }
              />
            </Route>
            <Route
              path="resource-type"
              element={
                <PermissionWrapper
                  permission={PERMISSIONS.CC.CC_RESOURCE_ROLE_RW}
                >
                  <ResourceTypeScreen />
                </PermissionWrapper>
              }
            />
            <Route path="roles-and-permissions">
              <Route
                index
                element={
                  // Landing shows Skills + Permissions + Billing roles — allow
                  // any of their permissions (nested routes still self-guard).
                  <PermissionWrapper
                    permission={[
                      PERMISSIONS.CC.CC_RESOURCE_RW,
                      PERMISSIONS.CC.CC_RESOURCE_ROLE_RW,
                    ]}
                    operator="OR"
                  >
                    <RolesAndPermissionsLanding />
                  </PermissionWrapper>
                }
              />
              <Route
                path="permissions"
                element={
                  <PermissionWrapper
                    permission={PERMISSIONS.CC.CC_RESOURCE_ROLE_RW}
                  >
                    <RolesAndPermissionScreen />
                  </PermissionWrapper>
                }
              />
              <Route
                path="skills"
                element={
                  <PermissionWrapper permission={PERMISSIONS.CC.CC_RESOURCE_RW}>
                    <SkillsScreen />
                  </PermissionWrapper>
                }
              />
              <Route
                path="billing-roles"
                element={
                  <PermissionWrapper
                    permission={PERMISSIONS.CC.CC_RESOURCE_ROLE_RW}
                  >
                    <BillingRolesScreen />
                  </PermissionWrapper>
                }
              />
              <Route
                path="role-profile"
                element={
                  // TODO(RP-PERM): swap to a dedicated role-profile permission
                  // once seeded. If a new key lands, add it to the landing
                  // route's PermissionWrapper array above too — that list is
                  // hand-maintained, not derived from the children config.
                  <PermissionWrapper
                    permission={PERMISSIONS.CC.CC_RESOURCE_ROLE_RW}
                  >
                    <RoleProfilesScreen />
                  </PermissionWrapper>
                }
              />
              <Route
                path="role-profile/:id"
                element={
                  <PermissionWrapper
                    permission={PERMISSIONS.CC.CC_RESOURCE_ROLE_RW}
                  >
                    <RoleProfileDetailScreen />
                  </PermissionWrapper>
                }
              />
            </Route>
            <Route
              path="company-profile"
              element={
                <PermissionWrapper
                  permission={PERMISSIONS.CC.CC_COMPANY_PROFILE_RW}
                >
                  <CompanyProfileScreen />
                </PermissionWrapper>
              }
            />
            <Route
              path="default-settings"
              element={
                <PermissionWrapper
                  permission={[
                    PERMISSIONS.SD.SD_TICKET_ALL_RW,
                    PERMISSIONS.SD.SD_TICKET_ASSIGNED_RW,
                  ]}
                  operator="OR"
                >
                  <DefaultSettingsScreen />
                </PermissionWrapper>
              }
            />
            <Route
              path={"subscription"}
              element={
                <PermissionWrapper
                  permission={PERMISSIONS.CC.CC_SUBSCRIPTION_RW}
                >
                  <SubscriptionHomeScreen />
                </PermissionWrapper>
              }
            />
            <Route
              path="branding"
              element={
                <PermissionWrapper permission={PERMISSIONS.CC.CC_BRANDING_RW}>
                  <BrandingScreen />
                </PermissionWrapper>
              }
            />
            <Route
              path="recurring-tickets"
              element={
                <PermissionWrapper
                  permission={PERMISSIONS.SD.SD_RECURRING_TICKET_RW}
                >
                  <RecurringTicketsPage />
                </PermissionWrapper>
              }
            />
            <Route path="agent-config" element={<AgentConfigScreen />} />
            <Route
              path="api-keys"
              element={
                <PermissionWrapper
                  permission={PERMISSIONS.CC.CC_API_MANAGEMENT_RW}
                >
                  <FeatureFlagWrapper flag="public_api">
                    <ApiKeysPage />
                  </FeatureFlagWrapper>
                </PermissionWrapper>
              }
            />
            <Route
              path="locations"
              element={
                <PermissionWrapper permission={PERMISSIONS.CC.CC_LOCATION_RW}>
                  <LocationScreen />
                </PermissionWrapper>
              }
            />
            <Route
              path="security"
              element={
                <PermissionWrapper permission={PERMISSIONS.CC.CC_SECURITY_RW}>
                  <SecurityScreen />
                </PermissionWrapper>
              }
            />
            <Route
              path={"notifications"}
              element={
                <PermissionWrapper
                  permission={PERMISSIONS.CC.CC_NOTIFICATION_RW}
                >
                  <Notifications />
                </PermissionWrapper>
              }
            />
            {/* Skills moved under Roles & permissions — redirect old links. */}
            <Route
              path="skills"
              element={
                <Navigate
                  to="/app/control-center/roles-and-permissions/skills"
                  replace
                />
              }
            />
            <Route path="team-members">
              <Route
                index
                element={
                  <PermissionWrapper permission={PERMISSIONS.CC.CC_RESOURCE_RW}>
                    <TeamMembersScreen />
                  </PermissionWrapper>
                }
              />
              <Route
                path=":id"
                element={
                  <PermissionWrapper permission={PERMISSIONS.CC.CC_RESOURCE_RW}>
                    <TeamMemberDetailScreen />
                  </PermissionWrapper>
                }
              />
            </Route>
            <Route
              path="boards-v2/tickets"
              element={
                <PermissionWrapper permission={PERMISSIONS.CC.CC_BOARD_RW}>
                  <BoardsV2Screen />
                </PermissionWrapper>
              }
            />
            <Route
              path="boards-v2/tickets/:boardId"
              element={
                <PermissionWrapper permission={PERMISSIONS.CC.CC_BOARD_RW}>
                  <BoardsV2DetailScreen />
                </PermissionWrapper>
              }
            />

            {/* <Route
              path="boards/:boardType"
              element={
                <PermissionWrapper permission={PERMISSIONS.CC.CC_BOARD_RW}>
                  <BoardsScreen />
                </PermissionWrapper>
              }
            /> */}
            {/* <Route
              path={"templates-set/:templateType"}
              element={
                <PermissionWrapper
                  permission={PERMISSIONS.CC.CC_NOTIFICATION_RW}
                >
                    <StanderdisedTemplateScreen />
                </PermissionWrapper>
              }
            /> */}
            <Route
              path={"templates-set/:templateType"}
              element={
                <PermissionWrapper
                  permission={[
                    PERMISSIONS.CC.CC_EMAIL_TEMPLATE_RW,
                    PERMISSIONS.CC.CC_SD_TEMPLATE_RW,
                    PERMISSIONS.CC.CC_CANNED_NOTE_RW,
                  ]}
                  operator="OR"
                >
                  <StanderdisedTemplateScreen />
                </PermissionWrapper>
              }
            >
              <Route
                path="tickets"
                index
                element={
                  <PermissionWrapper
                    permission={PERMISSIONS.CC.CC_SD_TEMPLATE_RW}
                  >
                    {/* dfdfdf */}
                    <TicketsTemplateTab />
                  </PermissionWrapper>
                }
              />
              <Route
                path="projects"
                index
                element={
                  <PermissionWrapper
                    permission={PERMISSIONS.CC.CC_SD_TEMPLATE_RW}
                  >
                    {/* projects */}
                    <ProjectsTemplateTab />
                  </PermissionWrapper>
                }
              />
              <Route
                path="tech-email"
                index
                element={
                  <PermissionWrapper
                    permission={PERMISSIONS.CC.CC_SD_TEMPLATE_RW}
                  >
                    {/* service desk */}
                    <TechData />
                  </PermissionWrapper>
                }
              />
              <Route
                path="customer-email"
                index
                element={
                  <PermissionWrapper
                    permission={PERMISSIONS.CC.CC_SD_TEMPLATE_RW}
                  >
                    {/* service desk */}
                    {/* <CustomerData /> */}
                    <TechData />
                  </PermissionWrapper>
                }
              />
            </Route>
            {/* <Route
              path={"templates-set"}
              element={
                <PermissionWrapper
                  permission={PERMISSIONS.CC.CC_NOTIFICATION_RW}
                >
                    <StanderdisedTemplateScreen />
                </PermissionWrapper>
              }
            /> */}
            <Route
              path={"email-signature"}
              element={
                <PermissionWrapper permission={PERMISSIONS.CC.CC_SIGNATURE_RW}>
                  <EmailSignatureScreen />
                </PermissionWrapper>
              }
            />
            <Route
              path="custom-fields/:customFieldType/:customFieldSubType?"
              element={
                <PermissionWrapper
                  permission={PERMISSIONS.CC.CC_CUSTOM_FIELD_RW}
                >
                  <CustomFieldsScreen />
                </PermissionWrapper>
              }
            />
            <Route
              path="service-categories"
              element={
                <PermissionWrapper
                  permission={PERMISSIONS.CC.CC_CUSTOM_FIELD_RW}
                >
                  <ServiceCategoriesScreen />
                </PermissionWrapper>
              }
            />
            <Route
              path="service-status"
              element={
                <PermissionWrapper
                  permission={PERMISSIONS.CC.CC_CUSTOM_FIELD_RW}
                >
                  <ServiceStatusScreen />
                </PermissionWrapper>
              }
            />
            <Route
              path="templates"
              element={
                <PermissionWrapper
                  permission={PERMISSIONS.CC.CC_SD_TEMPLATE_RW}
                >
                  <TemplateScreen />
                </PermissionWrapper>
              }
            >
              <Route
                path="tickets"
                index
                element={
                  <PermissionWrapper
                    permission={PERMISSIONS.CC.CC_SD_TEMPLATE_RW}
                  >
                    <TicketsTemplateTab />
                  </PermissionWrapper>
                }
              />
              <Route
                path="projects"
                element={
                  <PermissionWrapper
                    permission={PERMISSIONS.CC.CC_SD_TEMPLATE_RW}
                  >
                    <ProjectsTemplateTab />
                  </PermissionWrapper>
                }
              />
            </Route>
            {/* <Route path={"templates"} element={<TemplateScreen />} /> */}
            <Route
              path="checklist"
              element={
                <PermissionWrapper permission={PERMISSIONS.CC.CC_CHECKLIST_RW}>
                  <ChecklistScreen />
                </PermissionWrapper>
              }
            />
            <Route
              path="boards/:boardType"
              element={
                <PermissionWrapper permission={PERMISSIONS.CC.CC_BOARD_RW}>
                  <BoardsScreen />
                </PermissionWrapper>
              }
            />
            <Route
              path="canned-notes"
              element={
                <PermissionWrapper
                  permission={PERMISSIONS.CC.CC_CANNED_NOTE_RW}
                >
                  <CannedNotesScreen />
                </PermissionWrapper>
              }
            />
            <Route
              path="sla"
              element={
                <PermissionWrapper permission={PERMISSIONS.CC.CC_SLA_RW}>
                  <SLAScreen />
                </PermissionWrapper>
              }
            />
            <Route
              path="tags"
              element={
                <PermissionWrapper permission={PERMISSIONS.CC.CC_TAG_RW}>
                  <TagsScreen />
                </PermissionWrapper>
              }
            />
            <Route
              path={"qa"}
              element={
                <PermissionWrapper permission={PERMISSIONS.CC.CC_QA_RW}>
                  <QaRulesScreen />
                </PermissionWrapper>
              }
            />
            <Route
              path={"product"}
              element={
                <PermissionWrapper permission={PERMISSIONS.CC.CC_PRODUCT_RW}>
                  <ServiceDeskBillingProduct />
                </PermissionWrapper>
              }
            />
            <Route
              path={"expense"}
              element={
                <PermissionWrapper permission={PERMISSIONS.CC.CC_EXPENSE_RW}>
                  <ServiceDeskBillingExpense />
                </PermissionWrapper>
              }
            />
            <Route
              path={"timesheet"}
              element={
                <PermissionWrapper permission={PERMISSIONS.CC.CC_TIMESHEET_RW}>
                  <ServiceDeskTimesheetComponent />
                </PermissionWrapper>
              }
            />
            <Route path={"integrations"}>
              <Route
                index
                element={
                  <PermissionWrapper
                    permission={[
                      {
                        permissions: [PERMISSIONS.CC.CC_INTEGRATION_RW],
                        operator: "AND",
                      },
                      {
                        permissions: [
                          PERMISSIONS.SD.SD_TICKET_ALL_RW,
                          PERMISSIONS.SD.SD_TICKET_ASSIGNED_RW,
                        ],
                        operator: "OR",
                      },
                    ]}
                  >
                    <IntegrationHomeScreen />
                  </PermissionWrapper>
                }
              />
              {/* <Route path={":type"} element={<IntegrationsDetailsPage />} /> */}
              {/* ncentral routes */}
              <Route
                path={"ncentral"}
                element={
                  <PermissionWrapper
                    permission={[
                      {
                        permissions: [PERMISSIONS.CC.CC_INTEGRATION_RW],
                        operator: "AND",
                      },
                      {
                        permissions: [
                          PERMISSIONS.SD.SD_TICKET_ALL_RW,
                          PERMISSIONS.SD.SD_TICKET_ASSIGNED_RW,
                        ],
                        operator: "OR",
                      },
                    ]}
                  >
                    <IntegrationsDetailsPage />
                  </PermissionWrapper>
                }
              />
              {/* Level routes */}
              <Route
                path="level"
                element={
                  <PermissionWrapper
                    permission={[
                      {
                        permissions: [PERMISSIONS.CC.CC_INTEGRATION_RW],
                        operator: "AND",
                      },
                      {
                        permissions: [
                          PERMISSIONS.SD.SD_TICKET_ALL_RW,
                          PERMISSIONS.SD.SD_TICKET_ASSIGNED_RW,
                        ],
                        operator: "OR",
                      },
                    ]}
                  >
                    <LevelIntegrationsDetailsPage />
                  </PermissionWrapper>
                }
              />
              {/* Datto routes */}
              <Route
                path="datto"
                element={
                  <PermissionWrapper
                    permission={[
                      {
                        permissions: [PERMISSIONS.CC.CC_INTEGRATION_RW],
                        operator: "AND",
                      },
                      {
                        permissions: [
                          PERMISSIONS.SD.SD_TICKET_ALL_RW,
                          PERMISSIONS.SD.SD_TICKET_ASSIGNED_RW,
                        ],
                        operator: "OR",
                      },
                    ]}
                  >
                    <DattoIntegrationsDetailsPage />
                  </PermissionWrapper>
                }
              />
              {/* Pax8 routes */}
              <Route
                path="pax8"
                element={
                  <PermissionWrapper
                    permission={[PERMISSIONS.CC.CC_INTEGRATION_RW]}
                  >
                    <Pax8ConnectPage />
                  </PermissionWrapper>
                }
              />
              <Route
                path="pax8/configure"
                element={
                  <PermissionWrapper
                    permission={[PERMISSIONS.CC.CC_INTEGRATION_RW]}
                  >
                    <Pax8ConfigurePage />
                  </PermissionWrapper>
                }
              />
              <Route
                path="pax8/mapping"
                element={
                  <PermissionWrapper
                    permission={[PERMISSIONS.CC.CC_INTEGRATION_RW]}
                  >
                    <Pax8CustomerMappingPage />
                  </PermissionWrapper>
                }
              />
              <Route
                path="pax8/subscription-mapping"
                element={
                  <PermissionWrapper
                    permission={[PERMISSIONS.CC.CC_INTEGRATION_RW]}
                  >
                    <Pax8SubscriptionMappingPage />
                  </PermissionWrapper>
                }
              />
              <Route
                path="pax8/subscription-success"
                element={
                  <PermissionWrapper
                    permission={[PERMISSIONS.CC.CC_INTEGRATION_RW]}
                  >
                    <Pax8SubscriptionSuccessPage />
                  </PermissionWrapper>
                }
              />
              {/* Hudu routes */}
              <Route
                path="hudu"
                element={
                  <PermissionWrapper
                    permission={[
                      {
                        permissions: [PERMISSIONS.CC.CC_INTEGRATION_RW],
                        operator: "AND",
                      },
                      {
                        permissions: [
                          PERMISSIONS.SD.SD_TICKET_ALL_RW,
                          PERMISSIONS.SD.SD_TICKET_ASSIGNED_RW,
                        ],
                        operator: "OR",
                      },
                    ]}
                  >
                    <HuduIntegrationsDetailsPage />
                  </PermissionWrapper>
                }
              />

              {/* QB routes */}
              <Route
                path={"qb"}
                element={
                  <PermissionWrapper
                    permission={[
                      {
                        permissions: [PERMISSIONS.CC.CC_INTEGRATION_RW],
                        operator: "AND",
                      },
                      {
                        permissions: [
                          PERMISSIONS.SD.SD_TICKET_ALL_RW,
                          PERMISSIONS.SD.SD_TICKET_ASSIGNED_RW,
                        ],
                        operator: "OR",
                      },
                    ]}
                  >
                    <QbDetailsPage />
                  </PermissionWrapper>
                }
              >
                <Route
                  element={
                    <PermissionWrapper
                      permission={[
                        {
                          permissions: [PERMISSIONS.CC.CC_INTEGRATION_RW],
                          operator: "AND",
                        },
                        {
                          permissions: [
                            PERMISSIONS.SD.SD_TICKET_ALL_RW,
                            PERMISSIONS.SD.SD_TICKET_ASSIGNED_RW,
                          ],
                          operator: "OR",
                        },
                      ]}
                    >
                      <QbSuccessScreen />
                    </PermissionWrapper>
                  }
                  index
                />
                <Route path={"callback"} element={<QbCallbackScreen />} />
                <Route
                  path={"success"}
                  element={
                    <PermissionWrapper
                      permission={[
                        {
                          permissions: [PERMISSIONS.CC.CC_INTEGRATION_RW],
                          operator: "AND",
                        },
                        {
                          permissions: [
                            PERMISSIONS.SD.SD_TICKET_ALL_RW,
                            PERMISSIONS.SD.SD_TICKET_ASSIGNED_RW,
                          ],
                          operator: "OR",
                        },
                      ]}
                    >
                      <QbSuccessScreen />
                    </PermissionWrapper>
                  }
                />

                <Route
                  path={"configure"}
                  element={
                    <PermissionWrapper
                      permission={[
                        {
                          permissions: [PERMISSIONS.CC.CC_INTEGRATION_RW],
                          operator: "AND",
                        },
                        {
                          permissions: [
                            PERMISSIONS.SD.SD_TICKET_ALL_RW,
                            PERMISSIONS.SD.SD_TICKET_ASSIGNED_RW,
                          ],
                          operator: "OR",
                        },
                      ]}
                    >
                      <QbConfigurationWrapper />
                    </PermissionWrapper>
                  }
                />
              </Route>

              {/* Xero routes */}
              <Route
                path={"xero"}
                element={
                  <PermissionWrapper
                    permission={[
                      {
                        permissions: [PERMISSIONS.CC.CC_INTEGRATION_RW],
                        operator: "AND",
                      },
                      {
                        permissions: [
                          PERMISSIONS.SD.SD_TICKET_ALL_RW,
                          PERMISSIONS.SD.SD_TICKET_ASSIGNED_RW,
                        ],
                        operator: "OR",
                      },
                    ]}
                  >
                    <XeroDetailsPage />
                  </PermissionWrapper>
                }
              >
                <Route
                  element={
                    <PermissionWrapper
                      permission={[
                        {
                          permissions: [PERMISSIONS.CC.CC_INTEGRATION_RW],
                          operator: "AND",
                        },
                        {
                          permissions: [
                            PERMISSIONS.SD.SD_TICKET_ALL_RW,
                            PERMISSIONS.SD.SD_TICKET_ASSIGNED_RW,
                          ],
                          operator: "OR",
                        },
                      ]}
                    >
                      <XeroSuccessScreen />
                    </PermissionWrapper>
                  }
                  index
                />
                <Route path={"callback"} element={<XeroCallbackScreen />} />
                <Route
                  path={"success"}
                  element={
                    <PermissionWrapper
                      permission={[
                        {
                          permissions: [PERMISSIONS.CC.CC_INTEGRATION_RW],
                          operator: "AND",
                        },
                        {
                          permissions: [
                            PERMISSIONS.SD.SD_TICKET_ALL_RW,
                            PERMISSIONS.SD.SD_TICKET_ASSIGNED_RW,
                          ],
                          operator: "OR",
                        },
                      ]}
                    >
                      <XeroSuccessScreen />
                    </PermissionWrapper>
                  }
                />
                <Route
                  path={"configure"}
                  element={
                    <PermissionWrapper
                      permission={[
                        {
                          permissions: [PERMISSIONS.CC.CC_INTEGRATION_RW],
                          operator: "AND",
                        },
                        {
                          permissions: [
                            PERMISSIONS.SD.SD_TICKET_ALL_RW,
                            PERMISSIONS.SD.SD_TICKET_ASSIGNED_RW,
                          ],
                          operator: "OR",
                        },
                      ]}
                    >
                      <XeroConfigurationWrapper />
                    </PermissionWrapper>
                  }
                />
              </Route>

              {/* Stripe routes */}
              <Route
                path={"stripe"}
                element={
                  <PermissionWrapper
                    permission={[
                      {
                        permissions: [PERMISSIONS.CC.CC_INTEGRATION_RW],
                        operator: "AND",
                      },
                      {
                        permissions: [
                          PERMISSIONS.SD.SD_TICKET_ALL_RW,
                          PERMISSIONS.SD.SD_TICKET_ASSIGNED_RW,
                        ],
                        operator: "OR",
                      },
                    ]}
                  >
                    <StripeDetailsPage />
                  </PermissionWrapper>
                }
              >
                <Route
                  index
                  element={
                    <PermissionWrapper
                      permission={[
                        {
                          permissions: [PERMISSIONS.CC.CC_INTEGRATION_RW],
                          operator: "AND",
                        },
                        {
                          permissions: [
                            PERMISSIONS.SD.SD_TICKET_ALL_RW,
                            PERMISSIONS.SD.SD_TICKET_ASSIGNED_RW,
                          ],
                          operator: "OR",
                        },
                      ]}
                    >
                      <StripeSuccessScreen />
                    </PermissionWrapper>
                  }
                />
                <Route
                  path={"success"}
                  element={
                    <PermissionWrapper
                      permission={[
                        {
                          permissions: [PERMISSIONS.CC.CC_INTEGRATION_RW],
                          operator: "AND",
                        },
                        {
                          permissions: [
                            PERMISSIONS.SD.SD_TICKET_ALL_RW,
                            PERMISSIONS.SD.SD_TICKET_ASSIGNED_RW,
                          ],
                          operator: "OR",
                        },
                      ]}
                    >
                      <StripeSuccessScreen />
                    </PermissionWrapper>
                  }
                />
              </Route>

              {/* Ninja routes */}
              <Route
                path={"ninjaOne"}
                element={
                  <PermissionWrapper
                    permission={[
                      {
                        permissions: [PERMISSIONS.CC.CC_INTEGRATION_RW],
                        operator: "AND",
                      },
                      {
                        permissions: [
                          PERMISSIONS.SD.SD_TICKET_ALL_RW,
                          PERMISSIONS.SD.SD_TICKET_ASSIGNED_RW,
                        ],
                        operator: "OR",
                      },
                    ]}
                  >
                    <NinjaIntegrationsDetailsPage />
                  </PermissionWrapper>
                }
              />
              <Route
                path={"ninjaOne/success"}
                element={
                  <PermissionWrapper
                    permission={[
                      {
                        permissions: [PERMISSIONS.CC.CC_INTEGRATION_RW],
                        operator: "AND",
                      },
                      {
                        permissions: [
                          PERMISSIONS.SD.SD_TICKET_ALL_RW,
                          PERMISSIONS.SD.SD_TICKET_ASSIGNED_RW,
                        ],
                        operator: "OR",
                      },
                    ]}
                  >
                    <NinjaIntegrationsDetailsPage />
                  </PermissionWrapper>
                }
              />
              <Route
                path={"ninjaOne/form"}
                element={
                  <PermissionWrapper
                    permission={[
                      {
                        permissions: [PERMISSIONS.CC.CC_INTEGRATION_RW],
                        operator: "AND",
                      },
                      {
                        permissions: [
                          PERMISSIONS.SD.SD_TICKET_ALL_RW,
                          PERMISSIONS.SD.SD_TICKET_ASSIGNED_RW,
                        ],
                        operator: "OR",
                      },
                    ]}
                  >
                    <IntegrationsDetailsScreenPage />
                  </PermissionWrapper>
                }
              />
            </Route>
            <Route
              path={"archive/:type"}
              element={
                <PermissionWrapper permission={PERMISSIONS.CC.CC_ARCHIVED_RW}>
                  <ArchivePage />
                </PermissionWrapper>
              }
            />
            <Route
              path={"billing-template"}
              element={
                <PermissionWrapper
                  permission={PERMISSIONS.CC.CC_BILLING_TEMPLATE_RW}
                >
                  <ServiceDeskBillingEmailTemplateComponent />
                </PermissionWrapper>
              }
            />
            <Route
              path={"tax"}
              element={
                <PermissionWrapper permission={PERMISSIONS.CC.CC_TAX_RW}>
                  <ServiceDeskBillingTax />
                </PermissionWrapper>
              }
            />
            <Route
              path={"discount"}
              element={
                <PermissionWrapper permission={PERMISSIONS.CC.CC_TAX_RW}>
                  {/* <ServiceDeskBillingTax /> */}
                  <ServiceDeskDiscountTable />
                </PermissionWrapper>
              }
            />
            <Route
              path={"channels/:channelType"}
              element={
                <PermissionWrapper
                  permission={[
                    PERMISSIONS.CC.CC_CHANNEL_DESKTOP_RW,
                    PERMISSIONS.CC.CC_CHANNEL_MOBILE_RW,
                    PERMISSIONS.CC.CC_CHANNEL_EMAIL_RW,
                    PERMISSIONS.CC.CC_CHANNEL_TEAMS_RW,
                  ]}
                  operator="OR"
                >
                  <Channels />
                </PermissionWrapper>
              }
            />
            <Route
              path={"billing-settings"}
              element={
                <PermissionWrapper
                  permission={[
                    PERMISSIONS.CC.CC_BILLING_SETTING_RW,
                    PERMISSIONS.CC.CC_BILLING_TEMPLATE_RW,
                  ]}
                  operator="OR"
                >
                  <BillingSettingsScreen />
                </PermissionWrapper>
              }
            />
          </Route>
          {/* New Control Center */}

          {/* <Route path={"integrations"} element={<IntegrationHomeScreen />} />
          <Route
            path={"integrations/:type"}
            element={<IntegrationsDetailsPage />}
          /> */}

          <Route
            path={"customers"}
            element={
              <ModuleWrapper module="CUSTOMER">
                <CustomerOnBoardingWrapper>
                  <CustomersLayout />
                </CustomerOnBoardingWrapper>
              </ModuleWrapper>
            }
          >
            {/* <Route path={"overview"} element={<CustomerDashboardPage />} /> */}
            {/* SSo integration page */}

            <Route path={"customers"}>
              <Route index element={<CustomerHomeScreen />} />
              <Route path={":id/:type"} element={<CustomerDetailsScreen />}>
                <Route path={"sla"} element={<SlaTab />} />
                <Route
                  path={"billing-and-invoice"}
                  element={<BillingAndInvoiceTab />}
                />
                <Route path={"contract"} element={<ContractTab />} />
                <Route path={"general"} element={<GeneralSettingsTab />} />
                {/* <Route
                  path={"notification"}
                  element={<NotificationSettingsTab />}
                /> */}
                {/* <Route
                  path={"notification"}
                  element={<NotificationSettingsTab />}
                >
                  <Route index element={<Navigate to="new-tickets" />} />
                  <Route path={"new-tickets"} element={<NewTicketTab />} />
                  <Route
                    path={"response-on-tickets"}
                    element={<ResponseOnTicketTab />}
                  />
                  <Route
                    path={"closed-tickets"}
                    element={<ClosedTicketTab />}
                  />
                </Route> */}
                <Route
                  path={"notification"}
                  element={<CustomerUserNotifications />}
                />
              </Route>
            </Route>

            <Route path={"users"}>
              {/* <UserOnBoardingWrapper> */}
              <Route
                path={"home"}
                element={
                  <UserOnBoardingWrapper>
                    <UserHomeScreen />
                  </UserOnBoardingWrapper>
                }
              />
              <Route
                path=":id"
                element={
                  <UserOnBoardingWrapper>
                    <UserDetailsScreen />
                  </UserOnBoardingWrapper>
                }
              />
              {/* <Route path={"profile/:id"} element={<UserProfile />}>
                <Route path={"user-details"} element={<UserDetailsTab />} />
                <Route path={"documents"} element={<UserDocumentsTab />} />
                <Route path={"settings"} element={<UserPageSettingsTab />}>
                  <Route path={"security"} element={<UserSecurityTab />} />
                  <Route
                    path={"notification"}
                    element={<UserNotificationTab />}
                  />
                </Route>
                <Route path={"devices"} element={<UserDevicesTab />} />
                <Route path={"permissions"} element={<UserPermissionsTab />} />
                <Route path={"notes"} element={<UserNotesTab />} />
                <Route path={"managers"} element={<UserManagersTab />} />
              </Route> */}
              {/* </UserOnBoardingWrapper> */}
            </Route>
          </Route>
          <Route
            path={"dispatch-portal"}
            element={
              <ModuleWrapper module="SD">
                <CustomerOnBoardingWrapper>
                  <ServiceDeskLayout />
                </CustomerOnBoardingWrapper>
              </ModuleWrapper>
            }
          >
            <Route
              index
              element={
                <PermissionWrapper
                  permission={[
                    PERMISSIONS.SD.DISPATCH_PORTAL_RW,
                    PERMISSIONS.SD.DISPATCH_PORTAL_R,
                  ]}
                  operator="OR"
                >
                  <DispatchPortalScreen />
                </PermissionWrapper>
              }
            />
          </Route>
          <Route
            path={"service-desk"}
            element={
              <ModuleWrapper module="SD">
                <CustomerOnBoardingWrapper>
                  <ServiceDeskLayout />
                </CustomerOnBoardingWrapper>
              </ModuleWrapper>
            }
          >
            {/* <Route path={"overview"} element={<ServiceDeskDashboardPage />} /> */}
            {/* <Route
              path={"service-board"}
              element={<ServiceDeskServiceBoardPage />}
            /> */}
            <Route
              path={"tickets"}
              element={
                <PermissionWrapper
                  permission={[
                    PERMISSIONS.SD.SD_TICKET_ALL_RW,
                    PERMISSIONS.SD.SD_TICKET_ASSIGNED_RW,
                  ]}
                  operator="OR"
                >
                  <TicketsHomeScreen />
                </PermissionWrapper>
              }
            />

            <Route
              path={"tickets/:ticketId"}
              element={
                <PermissionWrapper
                  permission={[
                    PERMISSIONS.SD.SD_TICKET_ALL_RW,
                    PERMISSIONS.SD.SD_TICKET_ASSIGNED_RW,
                  ]}
                  operator="OR"
                >
                  <TicketDetailsScreen />
                </PermissionWrapper>
              }
            />
            {/* <Route path={"requests"} element={<ServiceDeskRequestsPage />} /> */}
            <Route
              path={"projects"}
              element={
                <PermissionWrapper
                  permission={[
                    PERMISSIONS.SD.SD_PROJECT_ALL_RW,
                    PERMISSIONS.SD.SD_PROJECT_ASSIGNED_RW,
                  ]}
                  operator="OR"
                >
                  <ProjectWrapper />
                </PermissionWrapper>
              }
            >
              <Route index element={<ProjectsHomeScreen />} />
              <Route path={":projectId"} element={<ProjectDetailsScreen />} />
              <Route
                path={":projectId/task/:taskId"}
                element={<TaskDetailsScreen />}
              />
            </Route>
            {/* <Route
              path={"recurring-tasks"}
              element={<ServiceDeskRecurringTasksPage />}
            /> */}
            {/* <Route path={"announcement-old/:type"} element={<PingHomePage />} /> */}
            <Route
              path={"announcement/:type"}
              element={
                <PermissionWrapper
                  permission={[
                    PERMISSIONS.SD.SD_ANNOUNCEMENT_ALL_RW,
                    PERMISSIONS.SD.SD_ANNOUNCEMENT_SELF_RW,
                  ]}
                  operator="OR"
                >
                  <AnnouncementsHomePage />
                </PermissionWrapper>
              }
            />

            <Route
              path={"timesheets"}
              element={
                <PermissionWrapper
                  permission={[
                    PERMISSIONS.SD.SD_TIMESHEET_ALL_RW,
                    PERMISSIONS.SD.SD_TIMESHEET_SELF_RW,
                  ]}
                  operator="OR"
                >
                  <TimesheetHomeScreen />
                </PermissionWrapper>
              }
            >
              <Route index element={<TimesheetTab />} />
              {/* <Route
                path={":startPeriod/:endPeriod"}
                element={<TimesheetDetailsTable />}
              /> */}
              <Route path={"submitted"} element={<SubmittedTimesheetTab />} />
              <Route path={"approvals"} element={<ApprovalsTable />} />
            </Route>
            <Route
              path="timesheets/:type/details"
              element={
                <PermissionWrapper
                  permission={[
                    PERMISSIONS.SD.SD_TIMESHEET_ALL_RW,
                    PERMISSIONS.SD.SD_TIMESHEET_SELF_RW,
                  ]}
                  operator="OR"
                >
                  <TimesheetDetailsScreen />
                </PermissionWrapper>
              }
            />
            <Route
              path="timesheets/approvals/:type/:id/details"
              element={
                <PermissionWrapper
                  permission={[
                    PERMISSIONS.SD.SD_TIMESHEET_ALL_RW,
                    PERMISSIONS.SD.SD_TIMESHEET_SELF_RW,
                  ]}
                  operator="OR"
                >
                  <TimesheetDetailsScreen />
                </PermissionWrapper>
              }
            />
            {/* <Route
              path="timesheets/approvals/:type/:id/details"
              element={<TimesheetTable />}
            /> */}
            <Route
              path="timesheets/approval/:type/details"
              element={
                <PermissionWrapper
                  permission={[
                    PERMISSIONS.SD.SD_TIMESHEET_ALL_RW,
                    PERMISSIONS.SD.SD_TIMESHEET_SELF_RW,
                  ]}
                  operator="OR"
                >
                  <TimesheetDetailsScreen />
                </PermissionWrapper>
              }
            />

            {/* <Route
              path={"calendar-and-timesheets"}
              element={<ServiceDeskCalendarAndTimesheetsPage />}
            /> */}
            {/* Old URL — dispatch moved to its own top-level route. */}
            <Route
              path={"dispatch-portal"}
              element={<Navigate to={"/app/dispatch-portal"} replace />}
            />
            <Route
              path={"qa-board"}
              element={
                <PermissionWrapper
                  permission={[
                    PERMISSIONS.SD.SD_QA_ALL_RW,
                    PERMISSIONS.SD.SD_QA_SELF_RW,
                  ]}
                  operator="OR"
                >
                  <QaBoardHomeScreen />
                </PermissionWrapper>
              }
            />
            <Route
              path={"qa-board/feedback/:serviceType/:type/:value"}
              element={
                <PermissionWrapper
                  permission={[
                    PERMISSIONS.SD.SD_QA_ALL_RW,
                    PERMISSIONS.SD.SD_QA_SELF_RW,
                  ]}
                  operator="OR"
                >
                  <QaCustomerFeedback />
                </PermissionWrapper>
              }
            />
          </Route>

          {/* reports */}
          <Route
            path={"reports"}
            element={
              <ModuleWrapper module="RPT">
                <CustomerOnBoardingWrapper>
                  <ReportsLayout />
                </CustomerOnBoardingWrapper>
              </ModuleWrapper>
            }
          >
            <Route path={"home"} element={<ReportsDashboardScreen />} />
            <Route path={"list"} element={<ReportsListScreen />} />
            <Route path={"list/:type"} element={<ReportDetailsScreen />} />
          </Route>
          {/* Billing  */}
          <Route
            path={"billing"}
            element={
              <ModuleWrapper module="BL">
                <CustomerOnBoardingWrapper>
                  <BillingLayout />
                </CustomerOnBoardingWrapper>
              </ModuleWrapper>
            }
          >
            <Route index element={<Navigate to={"ready-to-bill"} />} />
            <Route
              path={"ready-to-bill"}
              element={
                <PermissionWrapper
                  permission={[
                    PERMISSIONS.BL.BL_INVOICE_R,
                    PERMISSIONS.BL.BL_INVOICE_RW,
                  ]}
                  operator="OR"
                >
                  <BillingLayout />
                </PermissionWrapper>
              }
            >
              <Route index element={<ReadyToBillPage />} />
              {/* <Route path={"invoice"} element={<InvoiceDetailsPage />} /> */}
            </Route>
            {/* <Route
              path={"ready-to-bill2"}
              element={
                <PermissionWrapper
                  permission={[
                    PERMISSIONS.BL.BL_INVOICE_R,
                    PERMISSIONS.BL.BL_INVOICE_RW,
                  ]}
                  operator="OR"
                >
                  <BillingLayout />
                </PermissionWrapper>
              }
            >
              <Route index element={<ReadyToBillPage1 />} />
            </Route> */}
            <Route
              path={"recurring-invoice"}
              element={
                <PermissionWrapper
                  permission={[
                    PERMISSIONS.BL.BL_RECURRING_INVOICE_RW,
                    PERMISSIONS.BL.BL_RECURRING_INVOICE_R,
                  ]}
                  operator="OR"
                >
                  <RecurringInvoiceWrapper />
                </PermissionWrapper>
              }
            >
              <Route index element={<RecurringInvoicePage />} />
              <Route
                path={"create"}
                element={
                  <PermissionWrapper
                    permission={[PERMISSIONS.BL.BL_RECURRING_INVOICE_RW]}
                  >
                    <RecurringInvoiceDetailsPage />
                  </PermissionWrapper>
                }
              />
              <Route
                path={":invoiceId"}
                element={
                  RECURRING_INVOICE_V2_EDIT_ENABLED ? (
                    <EditRecurringInvoicePage />
                  ) : (
                    <RecurringInvoiceDetailsPage />
                  )
                }
              />
            </Route>
            {/*  */}
            {/* <Route
              path={"invoice/:mode/:type"}
              element={<InvoiceDetailsPage />}
            /> */}
            <Route
              path={"invoice/:mode/:type"}
              element={
                <PermissionWrapper
                  permission={[
                    PERMISSIONS.BL.BL_INVOICE_R,
                    PERMISSIONS.BL.BL_INVOICE_RW,
                  ]}
                  operator="OR"
                >
                  <InvoiceFormPage />
                </PermissionWrapper>
              }
            />
            <Route
              path={"invoice/:mode/:invoiceId/:type"}
              element={
                <PermissionWrapper
                  permission={[
                    PERMISSIONS.BL.BL_INVOICE_R,
                    PERMISSIONS.BL.BL_INVOICE_RW,
                  ]}
                  operator="OR"
                >
                  <InvoiceFormPage />
                </PermissionWrapper>
              }
            />
            {/* <Route
              path={"invoice/:mode/:invoiceId/:type"}
              element={<InvoiceDetailsPage />}
            /> */}
            <Route
              path={"invoice"}
              element={
                <PermissionWrapper
                  permission={[
                    PERMISSIONS.BL.BL_INVOICE_R,
                    PERMISSIONS.BL.BL_INVOICE_RW,
                  ]}
                  operator="OR"
                >
                  <InvoicePage />
                </PermissionWrapper>
              }
            >
              <Route index element={<InvoicePageTab />} />
              <Route path={"draft"} element={<InvoiceDraftTab />} />
              {/* <Route path={":id"} element={<InvoiceDetailsPage />} /> */}
            </Route>
            <Route
              path={"contracts"}
              element={
                <PermissionWrapper
                  permission={[
                    PERMISSIONS.BL.BL_CONTRACT_RW,
                    PERMISSIONS.BL.BL_CONTRACT_R,
                  ]}
                  operator="OR"
                >
                  <BillingLayout />
                </PermissionWrapper>
              }
            >
              <Route index element={<ContractsPage />} />
              {/* Edit is a full page; create and duplicate use the drawer. */}
              <Route path={":contractId"} element={<EditContractPage />} />
              {/* <Route
                path={"create"}
                element={
                  <PermissionWrapper
                    permission={[PERMISSIONS.BL.BL_CONTRACT_RW]}
                  >
                    <ContractDetailsPage />
                  </PermissionWrapper>
                }
              />
              <Route path={":id"} element={<ContractDetailsPage />} /> */}
            </Route>
            {/* <Route
              path="recurring-invoice"
              element={<BillingRecurringInvoiceDetails />}
            /> */}
            {/* </Route> */}
          </Route>
          <Route
            path="kb"
            element={
              <PermissionWrapper
                permission={[PERMISSIONS.KB.KB_KB_RW, PERMISSIONS.KB.KB_KB_R]}
                operator="OR"
              >
                <KbLayout />
              </PermissionWrapper>
            }
          >
            <Route index element={<Navigate to={"global-kb"} />} />
            <Route path="global-kb" element={<KbCentralKb />} />
            <Route path="starred" element={<KbStarred />} />
            <Route path="recently-visited" element={<KbRecentlyVisited />} />
            <Route path="folder/:folderId" element={<KbFolderView />} />
          </Route>
          <Route
            path="kb/create"
            element={
              <PermissionWrapper
                permission={[PERMISSIONS.KB.KB_KB_RW, PERMISSIONS.KB.KB_KB_R]}
                operator="OR"
              >
                <KbDetailScreen />
              </PermissionWrapper>
            }
          />
          <Route
            path="kb/document/:fileId"
            element={
              <PermissionWrapper
                permission={[PERMISSIONS.KB.KB_KB_RW, PERMISSIONS.KB.KB_KB_R]}
                operator="OR"
              >
                <KbDetailScreen />
              </PermissionWrapper>
            }
          />

          <Route path="404" element={<Error404Screen />} />
          <Route path="unauthorized" element={<UnautherizedScreen />} />
          <Route path="*" element={<ErrorInvalidLink />} />
        </Route>
      </SentryRoutes>
    </BrowserRouter>
  );
};

export default Router;
